export default class lightBoxService {
  initialConfiguration = {
    lightbox: {
      recognized: null,
      isLightBoxLoaderOn: false,
      validationData: {},
      identityFoundAt: '',
      consumerAuthorization: '',
      srciActionCode: '',
      checkoutProgress: false,
      isIdentityTypeMobile: false
    }
  };

  setInitialConfiguration () {
    this.setLightBoxConfigData(this.initialConfiguration)
  }

  getLightBoxConfigData () {
    const configDetails = JSON.parse(localStorage.getItem('lightBoxDetails'))

    if (configDetails) {
      return configDetails
    }

    return this.initialConfiguration
  }

  setLightBoxConfigData (configState) {
    localStorage.setItem('lightBoxDetails', JSON.stringify(configState))
  }
}
